export default __webpack_public_path__ + "static/media/depress.12005cbe.jpg";